import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Base Técnica de Colorimetría Profesional',
  subtitle: 'Construí fundamentos sólidos',
  accent: 'border-l-[#C8A96B]',
  items: ['Principios esenciales del color', 'Teoría cromática aplicada al cabello', 'Círculo cromático profesional', 'Colores primarios, secundarios y terciarios', 'Temperatura del color', 'Pigmentos naturales y artificiales', 'Comportamiento del color en cabello']
}, {
  icon: '🟢',
  title: 'Tomo 2 — Alturas, Reflejos y Lectura Profesional de Tintes',
  subtitle: 'Interpretá correctamente tonos y numeraciones',
  accent: 'border-l-[#C8A96B]',
  items: ['Escala de alturas de tono', 'Profundidad del color', 'Reflejos y matices', 'Lectura técnica de numeración', 'Nomenclaturas profesionales', 'Interpretación de cartas de color', 'Diferencias entre marcas y codificaciones']
}, {
  icon: '🟣',
  title: 'Tomo 3 — Neutralización Inteligente y Corrección de Subtonos',
  subtitle: 'Eliminá errores de neutralización',
  accent: 'border-l-[#C8A96B]',
  items: ['Subtonos cálidos no deseados', 'Amarillos, naranjas y rojos', 'Ley de neutralización', 'Corrección cromática aplicada', 'Cuándo neutralizar vs intensificar', 'Errores comunes de matización', 'Combinaciones correctivas']
}, {
  icon: '🟢',
  title: 'Tomo 4 — Formulación Profesional Paso a Paso',
  subtitle: 'Construí fórmulas con lógica profesional',
  accent: 'border-l-[#C8A96B]',
  items: ['Estructura de una fórmula profesional', 'Proporciones de mezcla', 'Selección de tonos', 'Oxidantes / reveladores', 'Tiempos de exposición', 'Formulación según diagnóstico', 'Lógica de construcción técnica']
}, {
  icon: '🟠',
  title: 'Tomo 5 — Decoloración Estratégica y Fondos de Aclaración',
  subtitle: 'Entendé la decoloración con criterio técnico',
  accent: 'border-l-[#C8A96B]',
  items: ['Niveles de aclaración', 'Fondos de aclaración', 'Comportamiento del pigmento residual', 'Selección de oxidantes', 'Tiempos y control técnico', 'Prevención de daño', 'Cuándo detener procesos']
}, {
  icon: '🔴',
  title: 'Tomo 6 — Corrección de Color y Rescate Profesional',
  subtitle: 'Resolvé errores reales del salón',
  accent: 'border-l-[#C8A96B]',
  items: ['Manchas y bandas', 'Sobrepigmentación', 'Tonos indeseados', 'Color desigual', 'Correcciones paso a paso', 'Protocolos de rescate profesional']
}];
const features = ['guías prácticas', 'aplicación inmediata', 'criterio técnico profesional', 'explicaciones claras', 'casos aplicables', 'uso real en salón'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-white py-16 px-5 relative overflow-hidden" data-id="element-317">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-318">
        <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-4" data-id="element-319">
          📚 LO QUE RECIBÍS
        </h2>
        <p className="text-center text-sm font-bold mb-10 uppercase tracking-widest text-[#C8A96B]" data-id="element-320">
          6 tomos listos para usar DESDE HOY
        </p>

        <div className="space-y-4 mb-10" data-id="element-321">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-slate-50 border border-slate-100 border-l-4 ${tomo.accent} rounded-2xl overflow-hidden transition-all hover:bg-white hover:shadow-md`} data-id="element-322">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-6 flex items-start gap-4 text-left" data-id="element-323">
                  <span className="text-3xl flex-shrink-0" data-id="element-324">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-325">
                    <h3 className="text-base font-black text-slate-900 mb-1" data-id="element-326">
                      {tomo.title}
                    </h3>
                    <p className="text-sm text-slate-500 font-medium" data-id="element-327">
                      {tomo.subtitle}
                    </p>
                  </div>
                  {isOpen ? <ChevronUp size={20} className="text-[#C8A96B] flex-shrink-0 mt-1" data-id="element-328" /> : <ChevronDown size={20} className="text-[#C8A96B]/30 flex-shrink-0 mt-1" data-id="element-329" />}
                </button>
                {isOpen && <div className="px-6 pb-6 pl-16" data-id="element-330">
                    <div className="space-y-3" data-id="element-331">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-332">
                          <CheckCircle2 className="text-[#C8A96B] flex-shrink-0" size={16} data-id="element-333" />
                          <span className="text-sm text-slate-600 font-medium" data-id="element-334">
                            {item}
                          </span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8" data-id="element-335">
          <h3 className="text-lg font-black text-center text-[#C8A96B] mb-6" data-id="element-336">
            ✨ Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-337">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-338">
                <CheckCircle2 className="text-[#C8A96B] flex-shrink-0" size={20} data-id="element-339" />
                <span className="text-sm text-slate-700 font-bold uppercase tracking-tight" data-id="element-340">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}